import { render, staticRenderFns } from "./policies-more-info-modal.vue?vue&type=template&id=402e1d96&scoped=true"
import script from "./policies-more-info-modal.vue?vue&type=script&setup=true&lang=ts"
export * from "./policies-more-info-modal.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./policies-more-info-modal.vue?vue&type=style&index=0&id=402e1d96&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "402e1d96",
  null
  
)

export default component.exports